export default {
  login: {
    title: 'منصة لخدمات البيانات في محطة الوقود',
    logIn: 'سجلت دينغ',
    ver: 'ملكية حقوق التأليف والنشر (ج) 2018-2025.',
    oket: 'شركة تشينغداو المحدودة للبرمجيات',
    log_fail: 'فشل تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    input: 'يرجى إدخال اسم المستخدم',
    input_pass: 'يرجى إدخال كلمة المرور'
  },
  route: {
    首页: 'الصفحة الأولى',
    限额管理: 'إدارة الحدود',
    报警值管理: 'إدارة شرطة',
    账户管理: 'إدارة الحسابات',
    组织管理: 'الإدارة التنظيمية',
    角色管理: 'إدارة الأدوار',
    功能管理: 'الإدارة الوظيفية',
    用户管理: 'إدارة المستخدمين'
  },
  navbar: {
    pwd_tip: 'كلمة المرور الخاصة بك منخفضة للغاية، يرجى تعديل كلمة المرور في أقرب وقت ممكن',
    updatepPwd: 'تعديل كلمة المرور',
    update_photo: 'تعديل الرأس',
    logOut: 'خروج تسجيل الدخول',
    username: 'اسم المستخدم',
    oldPwd: 'كلمة المرور الأصلية',
    newPwd: 'رمز جديد',
    choose: 'خيار',
    confirmNewPwd: 'تأكيد كلمة المرور الجديدة',
    input_old_pwd: 'يرجى إدخال كلمة المرور الأصلية',
    pwdDifference: 'إدخال كلمة المرور مرتين غير متسقة',
    inPutNewPwd: 'يرجى إدخال كلمة المرور الجديدة',
    inPutPwd: 'يرجى إدخال كلمة المرور',
    pwdValid: 'يرجى إدخال كلمة مرور لا يقل عن 6 أشخاص',
    update_success: 'نجاح التعديل، يرجى إعادة تسجيل الدخول',
    update_fail: 'فشل التعديل',
    right_image: 'يرجى تحميل النموذج الصورة الصحيح (JPGE/JPG/PNG/GIF)',
    over_image: 'حجم الصورة يتجاوز 1 م، يرجى إعادة الاختيار',
    change_image_name: 'يحتوي على رمز مميز في تسمية الصورة، رجاء اللّفّ',
    choose_image: 'يرجى تحديد رفع الرأس',
    image_success: 'تغيير الرأس ناجح',
    image_fail: 'فشل تغيير الرأس',
    menu_search: 'البحث في القائمة',
    totalLimit: 'المجموع',
    usedLimit: 'المستوى المستخدم',
    underwayLimit: 'جاري العمل',
    residualLimit: 'المبلغ المتبقي'
  },
  table: {
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    actions: 'تشغيل',
    edit: 'التحرير',
    open: 'تفعيل',
    close: 'إنه معطل',
    edit_menu: 'تحرير القائمة',
    edit_function: 'وظيفة التحرير',
    add_function: 'إضافة ميزات',
    changeOpen: 'لقد قمت بتعديل الحالة إلى -< لم تعد تعمل',
    changeClose: 'لقد قمت بتعديل الحالة إلى -',
    add_success: 'أضف النجاح',
    add_fail: 'أضف الفشل',
    edit_success: 'نجاح التحرير',
    edit_fail: 'فشل التحرير',
    choose: 'يرجى الاختيار',
    status: 'حالة',
    del: 'حذف',
    set_column: 'إعداد الأعمدة'
  },
  function: {
    fun: 'وظيفة',
    write_fun_name: 'يرجى إدخال اسم الوظيفة',
    fun_name: 'اسم وظيفي',
    write_fun: 'يرجى إدخال الميزات',
    fun_url: 'url وظيفة',
    write_fun_url: '.URL يرجى إدخال الميزات',
    is_menu: 'قائمة/وظيفة',
    menu: 'القائمة',
    write_menu: 'يرجى إدخال القائمة',
    menu_name: 'اسم القائمة',
    write_menu_name: 'يرجى إدخال اسم القائمة',
    is_choose: 'هل تختار؟',
    add_menu: 'قائمة الطعام',
    edit_menu: 'تحرير القائمة',
    parent_menu: 'قائمة الآباء',
    yes: 'هو',
    no: 'لا',
    able: 'تشغيل',
    disable: 'تعطيل',
    add_function: 'إضافة ميزات',
    edit_function: 'وظيفة التحرير',
    status_change_fail: 'فشل تعديل الحالة',
    choose_fun: 'يرجى اختيار الميزات'
  },
  button: {
    search: 'البحث',
    add: 'إضافة',
    refresh: 'تحديث البيانات'
  },
  org: {
    org_name: 'منظمة',
    org_parent_name: 'منظمة أبوية',
    write_org_name: 'يرجى إدخال اسم المنظمة',
    type: 'أنواع',
    address: 'العنوان',
    add_org: 'أضف الأنسجة',
    edit_org: 'تحرير التنظيم',
    name: 'اسم',
    org_name_exist: 'اسم المنظمة موجود بالفعل',
    failTopOrgList: 'فشل الحصول على قائمة عقدة الأنسجة',
    choose_org: 'يرجى اختيار المنظمة'
  },
  role: {
    role: 'الأدوار',
    write_role_name: 'يرجى إدخال اسم الدور',
    number: 'رقم تسلسلي',
    number_enter: 'يرجى إدخال الرقم التسلسلي',
    number_empty: 'الأرقام المسلسلة لا يمكن أن تكون فارغة',
    number_num: 'يجب أن يكون الرقم المسلسل موجباً',
    owning_organization: 'المنظمة التي تنتمي إليها',
    name: 'اسم',
    organization: 'منظمة',
    write: 'يرجى إدخال',
    able: 'تشغيل',
    disable: 'تعطيل',
    add_role: 'إضافة الشخصيات',
    edit_role: 'دور التحرير',
    role_del: 'سيتم حذف هذا الدور، هل يستمر؟',
    del_successfully: 'حذف بنجاح',
    del_fail: 'فشل حذف'
  },
  user: {
    user_name: 'اسم المستخدم',
    role_name: 'الأدوار',
    write_user_name: 'أدخل اسم المستخدم',
    remakes_password: 'إعادة ضبط كلمة المرور',
    nickname: 'أسماء',
    password: 'كلمة المرور',
    confirm_password: 'تأكيد كلمة المرور',
    email: 'صندوق البريد',
    space: 'لا يمكن أن يكون هناك فراغ في اسم المستخدم',
    less_name: 'يرجى إدخال ما لا يقل عن 4 أسماء للمستعمل',
    exist_user_name: 'اسم المستخدم موجود بالفعل',
    write_nickname: 'يرجى إدخال الاسم',
    write_password: 'يرجى إدخال كلمة المرور',
    sure_password: 'يرجى تأكيد كلمة المرور',
    inconsistent_password: 'كلمة المرور المعبأة مرتين غير متسقة',
    select_org: 'يرجى اختيار المنظمة',
    select_role: 'يرجى اختيار الدور',
    write_email: 'يرجى إدخال العنوان البريدي الصحيح',
    createTime: 'خلق الوقت',
    updateTime: 'وقت التعديل الأخير',
    loginTime: 'وقت تسجيل الدخول مؤخرا',
    add_user: 'أضف المستخدمين',
    search_error: 'فشل الاستعلام',
    reset: 'هذه العملية ستغير كلمة المرور إلى',
    is_continue: 'هل تستمر؟',
    reset_successfully: 'إعادة ضبط النجاح',
    reset_fail: 'إعادة ضبط الفشل',
    reset_cancle: 'تم إلغاء إعادة التعيين'
  },
  home: {
    please_enter: 'يرجى إدخال',
    please_select: 'يرجى الاختيار',
    cancle: 'إلغاء',
    confirm: 'تحديد',
    save: 'حفظc',
    back: 'العودة',
    stationName: 'اسم محطة الوقود',
    tankCode: 'رقم علب',
    oilType: 'نوع الزيت',
    formStatus: 'حالة',
    submit: 'تقديم',
    detail: 'التفاصيل',
    withdraw: 'سحب',
    refutation: 'سأتصل بك',
    download: 'تحميل',
    upload: 'تحميل',
    basic_information: 'المعلومات الأساسية',
    flowmeterNo: 'رقم مقياس التدفق',
    tankVolume: 'علب من الصليب',
    tankDiameter: 'قطر الصهريج',
    data_recording: 'سجلات البيانات',
    order: 'رقم تسلسلي',
    manualHeight: 'ارتفاع يدوي',
    levelGaugeHeight: 'ارتفاع مقياس السائل',
    liquidLevelMeterTemperature: 'مقياس درجة الحرارة السائل',
    flowmeterVolume: 'حجم مقياس التدفق',
    flowmeterTemperature: 'مقياس التدفق',
    alarmValues: 'إنذار',
    alarmValuesDescription: 'تعليمات الإنذار',
    capture: 'سأتصل بك',
    capture_reason: 'لماذا تتصل؟',
    submit_time: 'وقت التقديم',
    tabulation_time: 'الوقت المتوقع',
    drag_file: 'اسحب الملف هنا، أو',
    click_upload: 'انقر لتحميل',
    limit_upload: 'ولا يمكن تحميل ملفات XLSX/XLS إلا ولا تتجاوز 500KB',
    limit_files: 'تقييد اختيار ملف واحد',
    select_file: 'يرجى اختيار الملف',
    file_upload_successfully: 'تم تحميل الملف بنجاح',
    file_upload_failure: 'فشل تحميل الملفات',
    gasoline: 'البنزين',
    diesel_oil: 'وقود الديزل',
    to_be_submitted: 'في انتظار التقديم',
    pending_acceptance: 'تنتظر',
    process_acceptance: 'جاري',
    have_completed: 'اكتمل',
    delete: 'خلاء',
    called_back_reason: 'يرجى إدخال سبب الرد',
    confirm_commit: 'تأكيد تقديم هذه البيانات؟',
    tip: 'النصائح',
    submitted_successfully: 'وقد تم تقديم التقرير بنجاح، وحُدِّد الجدول الزمني بـ 72 ساعة',
    submission_failure: 'الفشل',
    confirm_undo: 'تأكيد سحب هذه البيانات؟',
    undo_successfully: 'إلغاء',
    undo_failure: 'الإبطال',
    capture_successfully: '. الإتصال',
    capture_failure: 'الفشل',
    del: 'باطلة',
    del_reason: 'سبب الفشل',
    enter_del_reason: 'يرجى إدخال سبب الإلغاء',
    del_successfully: 'الفشل',
    del_failure: 'الفشل',
    list_fail: 'فشل الحصول على البيانات',
    alarm_fail: 'فشل في الحصول على قائمة الإنذار',
    customer_download: 'تحميل الحجم',
    validateTankCode: 'رقم الصهريج رجاء أدخل الرقم الكامل',
    validateTankVolume: 'العلب رجاء أدخل الرقم الإيجابي',
    validateTankDiameter: 'يرجى إدخال الرقم الإيجابي لقطر الخزان',
    tankCodeNum: 'لا يمكن أن رقم العلبة أكثر من 127.',
    excel_download: 'تم التنزيل في صيغة إكسل',
    txt_download: 'تم تنزيله في شكل TXT.'
  },
  quota: {
    quota_num: 'الحدود',
    quota_enter: 'يرجى إدخال الكمية القصوى',
    quota_compare: 'وينبغي ألا يقل الحد الأقصى عن المستوى المستخدم',
    quota_edit: 'تعديل الحد',
    quota_used: 'المستوى المستخدم',
    quota_all: 'المجموع',
    updateTime: 'وقت التعديل'
  },
  alarm: {
    del: 'باطلة',
    explain_zh: 'ملاحظة إنذار (بالصينية)',
    explain_zh_enter: 'يرجى إدخال ملاحظة إنذار (بالصينية)',
    explain_en: 'مذكرة إنذار (بالانكليزية)',
    explain_en_enter: 'يرجى إدخال مذكرة إنذار (الإنجليزية)',
    explain_ar: 'مذكرة إنذار (العربية)',
    explain_ar_enter: 'يرجى إدخال مذكرة إنذار (العربية)',
    photo: 'الصور',
    del_successfully: 'الفشل',
    del_fail: 'الفشل',
    del_tip: 'سيتم إلغاء البيانات، هل تستمر؟',
    cancle_tip: 'تم إلغاء هذه العملية',
    jpg: '.JPG يمكن تحميل الصورة فقط تنسيق',
    jpg_size: 'لا يمكن تحميل الصورة بحجم يتجاوز 2 ميغابايت'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ar.js